"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeVideoUnderstanding = exports.nativeVideoUnderstandingResultSchema = exports.nativeVideoUnderstandingArgsSchema = exports.videoUnderstandingModelSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Valid models for video understanding
exports.videoUnderstandingModelSchema = zod_1.z
    .enum(['gemini-2.5-flash', 'gemini-2.5-pro', 'gemini-2.0-flash', 'gemini-2.0-flash-lite'])
    .describe('The Gemini model to use for video understanding');
// Args schema
exports.nativeVideoUnderstandingArgsSchema = zod_1.z.object({
    model: exports.videoUnderstandingModelSchema.default('gemini-2.0-flash'),
    videoURL: zod_1.z.string().describe('URL to the video file (MP4, MOV, etc.)'),
    prompt: zod_1.z.string().describe('Instructions or questions about the video content'),
    emitMode: common_1.emitModeSchema.default('single').describe('The mode to emit the result in.'),
});
// Result schema
exports.nativeVideoUnderstandingResultSchema = zod_1.z.object({
    text: zod_1.z.string().describe('The AI-generated analysis of the video content'),
});
// Tool definition
exports.nativeVideoUnderstanding = (0, common_1.createEmitModeToolMetadata)({
    id: 'nativeVideoUnderstanding',
    displayName: 'Video Understanding',
    displayDescription: 'Analyze and understand video content using AI models',
    category: 'ai',
    color: common_1.BRAND_COLORS.AI,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.AI),
    icon: 'default',
    argsSchema: exports.nativeVideoUnderstandingArgsSchema,
}, exports.nativeVideoUnderstandingResultSchema);
